import { computed, makeObservable, observable } from "mobx"

import type { TokenStore } from "@/domains/tokens"

import type { IIncentive, IncentiveStoreDAO } from "./interfaces"

/**
 * MobX store for a single incentive
 * Holds a reference to a TokenStore and computes rewardAmountUsd reactively
 */
export class IncentiveStore implements IIncentive {
  token: TokenStore
  rewardAmount: number

  constructor(dao: IncentiveStoreDAO) {
    this.token = dao.reward
    this.rewardAmount = dao.rewardAmount

    makeObservable(this, {
      token: observable,
      rewardAmount: observable,
      rewardAmountUsd: computed,
      hasReward: computed,
    })
  }

  /**
   * Computed USD value of the reward amount
   * Reactively updates when token price changes
   */
  get rewardAmountUsd(): number {
    return this.rewardAmount * this.token.bestPrice
  }

  /**
   * Whether this incentive has a meaningful reward value
   * Encapsulates the business logic for what constitutes a "reward"
   * Returns true if rewardAmountUsd > 0
   */
  get hasReward(): boolean {
    return this.rewardAmountUsd > 0
  }
}
